import { RIGHTS } from './catalog';
import { RightsMap, rightLevel } from './levels';

// Paramètres PowerBI d'une enseigne, tels que renvoyés par /getPowerBiMenu (valeurs '0' / '1')
export interface PowerBiWorkspaceParams {
  active?: string;
  customer_visible?: string;
  version?: string;
}

// Section DataViz V2 (BeOne : _primary_menu.php:345) : config active et ouverte au client avec da.powerbi.show,
// ou équipe interne (da.powerbi.show.internal). Même règle que l'API (src/Security/Rights/PowerbiAccess.php).
export const canSeeReporting = (rights: RightsMap, params: PowerBiWorkspaceParams | undefined): boolean => {
  if (!params || params.active !== '1' || params.version !== '2') return false;
  const customerAccess = params.customer_visible === '1' && rightLevel(rights, RIGHTS.powerbi.show) === 'full';
  return customerAccess || rightLevel(rights, RIGHTS.powerbi.showInternal) === 'full';
};

// Un rapport du menu (BeOne : _primary_menu.php:502)
export const canSeeReport = (rights: RightsMap, reportKey: string): boolean =>
  rightLevel(rights, `${RIGHTS.powerbi.reportPrefix}${reportKey}`) !== 'none';
